/**
 * @copyright 2022 Nuance Communications Inc.
 * All Rights Reserved.
 */
import * as React from "react";
import {
    Dropdown,
    IDropdownOption,
    IDropdownStyles,
    Stack,
    IIconProps,
    ActionButton
} from "@fluentui/react";

/**
 * Preview Actions properties
 */
interface IPreviewActionsProps {
    changesMade: boolean;
    language: string;
    onLanguageChange: (newLanguage: string) => void;
    onReset: () => void;
}

const options: IDropdownOption[] = [
    { key: "en-US", text: "English", selected: true },
    { key: "fr-FR", text: "French" }
];

const refreshIcon: IIconProps = { iconName: "Refresh" };

const dropdownStyles: Partial<IDropdownStyles> = {
    dropdown: {
        width: 200
    }
};
/* eslint-disable no-console */
const PreviewActions = (props: IPreviewActionsProps): JSX.Element => (
    <Stack horizontal verticalAlign="center">
        <ActionButton iconProps={refreshIcon} onClick={props.onReset} disabled={!props.changesMade}>
            Reset
        </ActionButton>

        <Dropdown
            defaultSelectedKey={props.language}
            options={options}
            styles={dropdownStyles}
            onChange={(_, selected) =>
                props.onLanguageChange(selected !== undefined ? selected.key.toString() : "")
            }
        />
    </Stack>
);
/* eslint-enable no-console */

export default PreviewActions;
